<template>
  <div class="MonthKaoHe">
    <div class="kaoheForm">
      <div class="item">
        <label for="assess_standard">店效标准(元/月) :</label>
        <input id="assess_standard" disabled v-model="kaoheForm.ASSESS_STANDARD" />
      </div>
      <div class="item" v-if="orderStatus=='1'">
        <label for="cp_c_store_open_date">店铺开店时间 :</label>
        <input id="cp_c_store_open_date" disabled v-model="kaoheForm.CP_C_STORE_OPEN_DATE" />
      </div>
      <div class="item" v-if="orderStatus=='2'">
        <label for="improve_end_date">店铺整改结束时间 :</label>
        <input id="improve_end_date" disabled v-model="kaoheForm.IMPROVE_END_DATE" />
      </div>
      <div class="item" v-if="orderStatus=='3'">
        <label for="keep_assess_start_date">维持开始时间 :</label>
        <input id="keep_assess_start_date" disabled v-model="kaoheForm.KEEP_ASSESS_START_DATE" />
      </div>
      <div class="item" v-if="orderStatus=='3'">
        <label for="keep_assess_end_date">维持结束时间 :</label>
        <input id="keep_assess_end_date" disabled v-model="kaoheForm.KEEP_ASSESS_END_DATE" />
      </div>
    </div>
    <component :is="currentTable" :tableConfig="tableConfig" />
  </div>
</template>
<script>


import CorssTable from "@/__component__/CorssTable";
import tool from "@/__utils__/tool";

export default {
  name: 'MonthKaoHe',
  components: {
    CorssTable,
  },
  data() {
    return {
      currentTable: null,
      orderStatus: undefined,
      kaoheForm: { //表单数据区
        ASSESS_STANDARD: '',  //店效标准(元/月)
        CP_C_STORE_OPEN_DATE: '',  //店铺开店时间
        IMPROVE_END_DATE: '',  //店铺整改结束时间
        KEEP_ASSESS_START_DATE: '',  //维持开始时间
        KEEP_ASSESS_END_DATE: '',  //维持结束时间
      },
      tableConfig: {
        width: {
          table_width: '100%',
          head_width: 100,
        },
        columns: [
          {
            title: '季度',
            key: 'QUARTER',
          },
          {
            title: '年份',
            key: 'YEAR',
          },
          {
            title: '月份',
            key: 'MONTH',
          },
          {
            title: '实际店效',
            key: 'SHOP_ASSESS_ACTUAL',
          },
          {
            title: '月考核情况',
            key: 'ASSESS_MONTH_SITUATION',
          },
          {
            title: '单季度考核情况',
            key: 'ASSESS_QUARTER_SITUATION',
          },
          {
            title: '支持状态',
            key: 'SUPPORT_STATUS',
          },
          {
            title: '实际支持金额',
            key: 'AMT_SUPPORT_ACTUAL',
          },
        ],
        data: []
      },
    };
  },
  computed: {

  },
  created() {

  },
  mounted() {
    this.generateComponent();
  },

  methods: {
    generateComponent() {
      const { tableName, tableId } = this.$route.params;
      const componentName = `${tableName}.${tableId}`;
      Vue.component(componentName, Vue.extend(CorssTable));
      this.currentTable = componentName;
      this.getInformation();
    },
    getInformation() {
      const { tableName, tableId, itemId } = this.$route.params;
      this.$network.post('/p/cs/scrm/selectAssessInfoOrder', { id: itemId == 'New' ? -1 : itemId }).then((res) => {
        if (res.data.code == 0) {
          this.orderStatus = res.data.data.cl_c_store_effect_assess_notices.COST_SUPPORT_TYPE;  //1:店铺新开 2.店铺整改 3.店铺维持
          this.setForm(res.data.data.cl_c_store_effect_assess_notices);
          this.yinse(res.data.data.cl_c_store_effect_assess_month_info);
          this.tableConfig.data = res.data.data.cl_c_store_effect_assess_month_info;
          console.log(res.data);
        }
      });
    },
    yinse(res) {
      res.map(item => {
        if (Number(item.QUARTER) > Number(item.QUARTER_NOW)) {
          item['color_style'] = 'small'
        } else if (Number(item.QUARTER) == Number(item.QUARTER_NOW)) {
          item['color_style'] = 'equal'
        } else if (Number(item.QUARTER) < Number(item.QUARTER_NOW)) {
          item['color_style'] = 'big'
        }
        item.QUARTER = "Q" + item.QUARTER;  //季度映射
        item.MONTH = item.MONTH + '月'; //月份映射
        if (item.ASSESS_MONTH_SITUATION == 1) {
          item.ASSESS_MONTH_SITUATION = '√';
        } else {
          item.ASSESS_MONTH_SITUATION = 'x';
        };
        if (item.ASSESS_QUARTER_SITUATION == 1) {
          item.ASSESS_QUARTER_SITUATION = '√';
        } else {
          item.ASSESS_QUARTER_SITUATION = 'x';
        };
        if (item.SUPPORT_STATUS == 1) {
          item.SUPPORT_STATUS = '已支持';
        } else {
          item.SUPPORT_STATUS = '未支持';
        }

      })
    },
    setForm(res) {
      let self = this;
      self.kaoheForm.ASSESS_STANDARD = res.ASSESS_STANDARD;  //店效标准(元/月)
      self.kaoheForm.CP_C_STORE_OPEN_DATE = tool.standardTimeConversion(res.CP_C_STORE_OPEN_DATE);  //店铺开店时间
      self.kaoheForm.IMPROVE_END_DATE = tool.standardTimeConversion(res.IMPROVE_END_DATE);  //店铺整改结束时间
      self.kaoheForm.KEEP_ASSESS_START_DATE = tool.standardTimeConversion(res.KEEP_ASSESS_START_DATE); //维持开始时间
      self.kaoheForm.KEEP_ASSESS_END_DATE = tool.standardTimeConversion(res.KEEP_ASSESS_END_DATE);  //维持结束时间
    }
  }
};
</script>
<style lang="less">
.MonthKaoHe {
  .kaoheForm {
    display: flex;
    margin: 10px 0;
    padding: 0 10px;
    .item {
      padding: 0 5px;
      display: flex;
      label {
        display: inline-block;
        vertical-align: middle;
        white-space: nowrap;
        line-height: 26px;
      }
      input {
        height: 26px;
        padding: 0 5px;
        margin-left: 3px;
      }
      input[disabled] {
        background-color: #f4f4f4;
        border: 1px solid #d8d8d8;
      }
    }
  }
}
</style>